module.exports = __webpack_public_path__ + "img/pix.c0eadc05.svg";